<template>
  <div class="customer-payment body">
    <el-container>
      <!-- <CustomersAside /> -->
      <el-main>
        <el-row :gutter="10">
          <el-col :xl="9" :lg="9" :md="12" :sm="12">
            <div class="bg-White h">
              <SearchCustomers
                ref="searchCustomersComponent"
                :searchOnly="true"
                :customer="customer"
                @selectedCustomer="selectedCustomer"
                :productsLength="productsLength"
                :productSearch="false"
                :showLabel="true"
              />
            </div>
          </el-col>
          <el-col :xl="9" :lg="9" :md="12" :sm="12" class="bg-White">
            <div class="block p-3 mt-2">
              <label for="" class="d-block"> اختر مده زمنيه</label>
              <el-date-picker
                style="width: 100%"
                @change="getCustomerReportNew"
                v-model="dateRange"
                type="daterange"
                range-separator="الي"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                start-placeholder="بداية الفترة"
                end-placeholder="نهاية الفترة"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="12" :sm="12" v-if="customer">
            <div class="bg-White result">
              <p class="p-3 mt-2">
                <span
                  class="num"
                  v-if="
                    +customer.balance +
                      +customer.account >=
                    0
                  "
                  >{{
                    numberToFixed(
                      +customer.balance +
                        +customer.account
                    )
                  }}</span
                >
                <span class="num" v-else>{{
                  numberToFixed(
                    +customer.balance +
                      +customer.account *
                      -1
                  )
                }}</span>
                <br />
                <span
                  v-if="
                    +customer.balance +
                      +customer.account >=
                    0
                  "
                  >مدين</span
                >
                <span v-else>دائن</span>
              </p>
            </div>
          </el-col>
          <el-col :lg="2" :md="12" :sm="12">
            <div class="bg-White result" style="height: 100%" v-if="customer">
              <el-button
                type="success"
                @click="printAllProducts"
                icon="el-icon-printer"
              ></el-button>
            </div>
          </el-col>
        </el-row>
        <el-row
          class="bg-White mt-2 p-3"
          v-if="customer"
          justify="space-between"
        >
          <el-col :xl="18" :lg="18" :md="18" :sm="24">
            كشف حساب العملاء
          </el-col>
          <el-col :xl="6" :lg="6" :md="6" :sm="24">
            <label for="code"></label>
            <el-input
              placeholder="بحث بالبيان "
              autofocus
              type="text"
              @focus="$event.target.select()"
              v-model="description"
            ></el-input>
          </el-col>
        </el-row>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column width="70" label="السند" prop="operation_id">
          </el-table-column>
          <el-table-column
            sortable
            width="155"
            label="التوقيت"
            prop="created_at"
          >
            <template slot-scope="scope">
              {{ scope.row.created_at | moment(" Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
          <el-table-column width="330" label="بيان" prop="description">
          </el-table-column>
          <el-table-column label="مدين">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">{{ scope.row.amount }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column label="دائن">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0">{{ scope.row.amount }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column label="الرصيد" prop="account"></el-table-column>
          <el-table-column label="بواسطة" prop="user.name"> </el-table-column>
          <el-table-column
            label="اجراء"
            v-if="accessLinks('edit_customer_payment_movement')"
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.operation_type == 1 || scope.row.operation_type == 4
                "
                size="mini"
                type="warning"
                title="تعديل"
                icon="el-icon-edit"
                @click="edit(scope.row)"
              >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <el-dialog
      :fullscreen="false"
      title="تعديل قيمة بيان"
      :visible.sync="editMode"
    >
      <el-form v-model="form">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="المبلغ">
              <el-input v-model="form.actual_amount" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="المبلغ الجديد">
              <el-input v-model="form.cost"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="update">حفظ التعديلات</el-button>
        <el-button class="mr-3" @click="editMode = false">إلغاء</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SearchCustomers from "@/components/Customers/SearchWithoutAdd.vue";
// import CustomersAside from "@/components/CustomersAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  name: "CustomerReport",
  components: { SearchCustomers },
  data() {
    return {
      false: false,
      true: true,
      dateRange: null,
      tableData: [],
      allData: [],
      type: null,
      description: "",
      productsLength: 0,
      customer: null,
      payments: 0,
      sales: 0,
      account: 0,
      editMode: false,
      form: {
        account: 0,
        amount: "",
        cost: 0,
        created_at: "",
        customer_id: 0,
        description: "",
        id: 0,
        operation_id: 0,
        operation_type: 0,
        role_name: "",
        type: 0,
        updated_at: "",
        user: null,
        user_id: 0,
      },
    };
  },
  created() {
    console.log("this.$route.params", this.$route.query);
    if (this.$route.query.customer_id > 0) {
      this.getCustomer();
    }
    console.log(this.customer);
  },
  methods: {
    getCustomer() {
      axiosApi
        .get(`customers/${this.$route.query.customer_id}`)
        .then((res) => {
          console.log(res);
          this.customer = res.data;
          this.$refs.searchCustomersComponent.setValue(this.customer);
          // this.getCustomerReport();
          this.getCustomerReportNew();
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      // this.getCustomerReport();
      this.getCustomerReportNew();
      setTimeout(() => {
        // document.getElementById("paied").focus();
      }, 100);
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getCustomerReport() {
      if (this.customer) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        let url = `customers/interval-report/${this.customer.id}`;
        if (this.dateRange != null) {
          url += `?start_date=${this.dateRange[0]}`;
          url += `&end_date=${this.dateRange[1]}`;
        }

        axiosApi
          .get(url)
          .then((response) => {
            this.customer_old_account = response.data.old;

            this.tableData = response.data.customer_report;

            const vm = this;

            this.tableData.unshift({
              comment: "رصيد سابق",
              cost: vm.numberToFixed(response.data.old),
              created_at: "",
              donne_at: "",
              id: "",
              type: 1,
            });
            /**
             *
             *
             */
            let sum = 0;
            let sales = 0;
            let payment = 0;
            this.tableData.map(function (value) {
              if (value["type"] == 1) {
                sum += Number(value["cost"]);
                sales += Number(value["cost"]);
              } else {
                sum -= Number(value["cost"]);
                payment += Number(value["cost"]);
              }

              value["account"] = vm.numberToFixed(sum);
            });

            if (this.customer_old_account > 0) {
              sales += this.customer_old_account;
            } else {
              payment += this.customer_old_account * -1;
            }
            this.account = sales - payment;

            this.payments = payment;
            this.sales = sales;

            this.allData = this.tableData;
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        this.allData = [];
        this.tableData = [];
      }
    },
    getCustomerReportNew() {
      if (this.customer) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let url = `/logs/customers/${this.customer.id}`;
        if (this.dateRange != null) {
          url += `?start=${this.dateRange[0]}`;
          url += `&end=${this.dateRange[1]}`;
        }
        axiosApi
          .get(url)
          .then((response) => {
            this.tableData = response.data.customer_report;
            this.customer = response.data.customer;
            const vm = this;
            if (this.dateRange != null) {
              this.tableData.unshift({
                operation_id: "",
                description: "رصيد سابق",
                account: vm.numberToFixed(response.data.old),
                created_at: this.dateRange[0],
                amount: vm.numberToFixed(response.data.old),
                type: 1,
                user: { name: "" },
              });
            }
            let sum = 0;
            let sales = 0;
            let payment = 0;
            this.tableData.map(function (value) {
              if (value["type"] == 1) {
                sum += Number(value["amount"]);
                sales += Number(value["amount"]);
              } else {
                sum -= Number(value["amount"]);
                payment += Number(value["amount"]);
              }
              value["account"] = vm.numberToFixed(sum);
            });
            this.account = sales - payment;
            this.payments = payment;
            this.sales = sales;
            this.allData = this.tableData;
            console.log(response);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        this.allData = [];
        this.tableData = [];
      }
    },
    printAllProducts() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: this.tableData,
      //   type: "CustomersReport",
      //   customer: { ...this.customer, isCustomer: true },
      //   dateRange: this.dateRange,
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    edit(repot) {
      this.editMode = true;
      this.form = { ...repot, cost: 0 };
    },
    update() {
      console.log(this.form);
      axiosApi
        .put(`customer-payments/${this.form.operation_id}`, this.form)
        .then(() => {
          this.editMode = false;
          this.getCustomerReportNew();
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
  watch: {
    description: function (newValue) {
      this.tableData = this.allData;
      let query = newValue.trim();
      if (query != "") {
        this.tableData = this.tableData.filter((value) => {
          return value.description.includes(query);
        });
      } else {
        this.tableData = this.allData;
      }
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 70%;
  overflow-y: scroll;
}
</style>
